namespace GeniuzPOS.Purchase {
    export enum LevelApp {
        lv1 = 1,
        lv2 = 2,
        lv3 = 3,
        lv4 = 4,
        lv5 = 5,
        lv6 = 6,
        lv7 = 7,
        lv8 = 8,
        lv9 = 9
    }
    Serenity.Decorators.registerEnumType(LevelApp, 'GeniuzPOS.Purchase.LevelApp');
}
